import { isViewerQualityMode, } from '../../engine/streamrapp/viewerQualityOptions';
import { safeRetrieve, safeStore } from '../../utils/storage';
/**
 * Device-scoped viewer quality preference (upload capacity is a property of
 * the device and its network, not of a session): the forced mode, if any,
 * and the last automatic decision with its time.
 */
export class ViewerQualityStore {
    static instance;
    static getInstance() {
        if (!ViewerQualityStore.instance) {
            ViewerQualityStore.instance = new ViewerQualityStore();
        }
        return ViewerQualityStore.instance;
    }
    constructor() { }
    getMode() {
        const stored = safeRetrieve('viewerQuality');
        return isViewerQualityMode(stored) ? stored : 'auto';
    }
    setMode(mode) {
        safeStore('viewerQuality', mode === 'auto' ? undefined : mode);
    }
    getRemembered() {
        return safeRetrieve('viewerQualityMemory', (value) => {
            const v = value;
            if ((v.quality === 'high' || v.quality === 'low') &&
                typeof v.atMs === 'number') {
                return { quality: v.quality, atMs: v.atMs };
            }
            throw 'Invalid remembered viewer quality';
        });
    }
    remember(quality, atMs = Date.now()) {
        const data = { quality, atMs };
        safeStore('viewerQualityMemory', data);
    }
    forget() {
        safeStore('viewerQualityMemory', undefined);
    }
}
